import React, { Component } from 'react'
import { TextField } from '@mui/material'
import { injectIntl } from 'react-intl'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import FieldWrapper from '../FieldRowWrapper'
import {
  ensurePersianNumber,
  ensureEnglishNumber,
  toPersianDigit,
} from '../../../helpers/generalHelpers'
import { digitByLocal } from 'helpers/formatters/digit'
import settings from '../../../settings'

import './number-input.css'
import { getRawMessage } from 'locale'
import RawHtml from 'stories/components/RawHtml'

const { locales } = settings
class NumberInput extends Component {
  constructor(props) {
    super(props)
    this.state = { hasFocus: false }
  }

  onInputChange = (event) => {
    const { value } = event.target
    this.props.onChange(ensureEnglishNumber(value, this.shouldAcceptDecimal()))
  }

  onInputFocus = () => {
    this.setState({ hasFocus: true }, () => {
      this.props.onFocus && this.props.onFocus()
    })
  }

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur()
    })
  }

  getInputValue = () => {
    const { value } = this.props
    if ([null, undefined, ''].includes(value)) return ''

    return this.shouldApplyMasking()
      ? ensurePersianNumber(toPersianDigit(value), this.shouldAcceptDecimal())
      : value
  }

  generateDescription = (desc = '', max, min) => {
    if (!min && !max) return <RawHtml content={desc} />
    const minVal = min
      ? `${getRawMessage('form.fields.number.minValue')}: ${digitByLocal(min)}`
      : ''
    const maxVal = max
      ? `${getRawMessage('form.fields.number.maxValue')}: ${digitByLocal(max)}`
      : ''
    return (
      <>
        {' '}
        <span>{'(' + minVal + ' ' + maxVal + ')'}</span>{' '}
        {<RawHtml content={desc} />}{' '}
      </>
    )
  }

  shouldApplyMasking = () => {
    const {
      intl: { locale = locales.fa },
    } = this.props
    if (locale === locales.fa) return true

    return false
  }

  shouldAcceptDecimal = () => {
    const { decimalPlace } = this.props

    if (!decimalPlace || decimalPlace === '0') return false
    return true
  }

  render() {
    const {
      label = '',
      name = '',
      placeholder,
      min_value: min,
      max_value: max,
      required,
      touched,
      error,
      description,
      customized,
      disabled,
    } = this.props

    const classNames = {
      'formz-number-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }
    const inputProps = {
      name,
      min,
      max,
      type: 'text',
      value: this.getInputValue(),
      onChange: this.onInputChange,
      onFocus: this.onInputFocus,
      onBlur: this.onInputBlur,
      placeholder,
      disabled,
    }
    if (customized)
      return (
        <FieldRowWrapper
          className={classNames}
          error={error}
          touched={touched ? touched.toString() : undefined}
        >
          <label className="formz-field-and-label-holder">
            <div className="formz-input-title">
              {label} {required && '(*)'}
            </div>
            <div className="formz-field-description">
              {this.generateDescription(description, max, min)}
            </div>
            <input className="formz-input-field ltr-on-type" {...inputProps} />
          </label>
        </FieldRowWrapper>
      )
    return (
      <FieldWrapper
        error={error}
        touched={touched ? touched.toString() : undefined}
        fullWidth={this.props.fullWidth}
      >
        <TextField
          {...inputProps}
          label={label || placeholder}
          error={Boolean(error)}
        />
      </FieldWrapper>
    )
  }
}

export default injectIntl(NumberInput)
